<!-- Modal.vue -->
<template>
    <div class="container">
        <div class="payment-detail">
            <div class="pricing-detail">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                     <img src="/images/logo2.png"  alt="" class="img-fluid py-3" style="max-width: 150px;" />
<!--                        <img src="asserts/Finja Business.png" alt="Your Logo" class="img-fluid py-3" style="max-width: 150px;">-->
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1 class="mt-4">Revised Schedule of Charges (WEF Jan 2024)</h1>
                        <p>Thank you for your confidence and continued relationship with finja. We hope Finja Bussiness
                            continues to add value to your bussiness and gives you enhanced independence to manage your digital
                            financial transactions </p>
                        <p>In line with market practice, we are updating our Schedule of charges with effect from:</p>
                        <h1 class="charge-date">January 5th, 2024</h1>
                        <p>The updated pricing has been determined in accordance with industry standards and has been conceived
                            in light of industry best practices.</p>
                    </div>
                </div>
                <div class="row mt-2 mb-2">
                    <div class="pricing">
                        <div class="pricing-table table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>Products</th>
                                    <th>Pricing</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <p class="ptable-title">Finja Bussiness <br />
                                            <span>(Monthly Subscription Charges)</span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="ptable-title">PKR. 7,500/-<br />
                                            <span> (PKR Seven Thousand Five Hundred Only) </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="ptable-title">Payments<br />
                                            <span> (Transaction Service Fee)</span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="ptable-title">0.3% per transation
                                            <!-- OR PKR
                                            200
                                            Per Transfer <sup>*1</sup><br />
                                           <span> (whichever is lower)</span> -->
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="ptable-title">Evergreen Credit Line<br />
                                            <span> (Application Fee)</span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="ptable-title">PKR. 5,000/-<br />
                                            <span> (PKR Five Thousand Only) </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="ptable-title">Evergreen Credit Line<br />
                                            <span>(Pro-Rate/ Per Day Charges)</span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="ptable-title">0.12% per day on utilized credit
                                            <!-- OR PKR
                                            200
                                            Per Transfer <sup>*1</sup><br />
                                           <span> (whichever is lower)</span> -->
                                        </p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p class="charge-date remarks"> <sup>1*</sup>Transactions below PKR. 25,000 (PKR Twenty Five Thousand
                            Only)will not be charged </p>
                        <p class="charge-date remarks"> <sup>2*</sup>Revolving credit facility with a maximum tenure of 30 days.
                        </p>
                        <p>We appreciate your continued support in Finja's overall products and services and assure you of our
                            commitment in delivering you best-in-class financial services.</p>
                        <p>We look forward to further strengthening our bussiness relationship with you and your organization.
                            For any comments, queries ,and /or feedback, please feel free to reach out to us.</p>
                        <h5 class="mb-4 mt-2">Email: <span class="email charge-date">Sales.support@flsl.pk</span></h5>
                        <p class="charge-date remarks">Relationship Team:</p>
                        <ul>
                            <li>Faisal Alvi (Manager Business Development)</li>
                            <li>Hassan Ali (Manager Customer Relationship)</li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showModal: false,
            };
        },
        methods: {
            openModal() {
                this.showModal = true;
            },
            closeModal() {
                this.showModal = false;
                console.log("button",this.showModal)
                // this.$emit('showModal');
            }
        },
    };
</script>

<style scoped>
    .container{
        max-width: 590px;
    }
    .payment-detail{
        background-color: #e8e6e6;
        padding: 26px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .pricing-detail{
        background-color: white;
        padding: 23px;
    }

    h1 {
        font-weight: bold;
        font-size: 16px;
        line-height: normal;
    }

    p {
        font-size: 12px;
    }

    h5 {
        font-weight: bold;
    }
    h5 .email {
        font-weight: 400;
        padding-left: 4px;
    }

    p {
        font-weight: 120;
        line-height: 22px;
    }

    .charge-date {
        color: #eb401f
    }


    .remarks {
        font-weight: bold;
    }
    .pricing{
        padding: 0;
    }

    .pricing .table {
        border-top: 1px solid #ddd;
        background: #fff;
        width: 470px;
    }

    .pricing .table th,
    .pricing .table {
        text-align: center;
    }

    .pricing .table th,
    .pricing .table td {
        padding: 16px 2px;
        border-left: 1px solid #ddd;
    }

    .pricing .table th {
        width: 25%;
        font-size: 21px;
        font-weight: 400;
        border-bottom: 0;
        background: #f57e24;
        color: white;
    }

    .pricing .table td {
        padding-left: 34px;
        text-align: left;
        padding-top: 17px;
        background: #ec5b22;
    }

    .pricing tr td .ptable-title {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        line-height: 24px;
    }

    .ptable-title span {
        font-size: 9px;
        font-weight: normal;
        color: #fff;
        line-height: 30px;
    }

    .pricing .ptable-price {
        display: block;
    }

    .pricing tr td {
        font-size: 16px;
        line-height: 32px;
    }
</style>